import { ID } from "../core/id";
import { Balance } from "../types/economic.type";
import { JobView } from "../types/job.type";
import { Place } from "../types/place.type";
import { Push } from "../types/push.type";
import { WorkView } from "../types/work.type";

export interface StoreExecutor {
  jobs: VIWDataMap<JobView>;
  works: VIWDataMap<WorkView>;
  places: VIWDataMap<Place>;
  pushs: VIWDataMap<Push>;
  balance: Balance;
}
export type StoreExecutorTable = keyof StoreExecutor;
export enum EStoreExecutorTable {
  JOBS = "jobs",
  WORKS = "works",
  PLACES = "places",
  PUSHES = "pushs",
  BALANCE = "balance",
}
// Maps

export interface VIWDataMap<T> {
  [id: string]: T;
}

export interface GetStoreExecutorRequest {
  current_url: string;
}

export interface GetStoreExecutorResponse {
  map: StoreExecutor;
}

export interface EventSyncChange {
  patchs: PatchChange[];
}
export interface PatchChange {
  type: StoreExecutorTable;
  id: ID;
}

export interface SyncMapRequest extends EventSyncChange { }

export interface SyncMapResponse {
  map: StoreExecutor;
}
